export const _en = {
    name: {
        label: "Name"
    },
    description: {
        label: "Description"
    },
    settableOnHumanResource: {
        label: "Enable on human resource"
    },
    settableOnMaterialResource: {
        label: "Enable on material resource"
    },
    isDry: {
        label: "Is a category of DRY activities"
    },
    isUnavailabilityCategory: {
        label: "Is a category of unavailability"
    },
    refDivisionId: {
        label: "Service"
    },
    counter: {
        label: "Counter"
    }
};

export const _fr = {
    name: {
        label: "Nom"
    },
    description: {
        label: "Description"
    },
    settableOnHumanResource: {
        label: "Active sur les ressources humaines"
    },
    settableOnMaterialResource: {
        label: "Active sur les ressources matérielles"
    },
    isDry: {
        label: "Est une catégorie d'activités DRY"
    },
    isUnavailabilityCategory: {
        label: "Les activités de cette catégorie sont de l’indisponibilité"
    },
    refDivisionId: {
        label: "Service"
    },
    counter: {
        label: "Compteur"
    }
};